import { IAccountStatus, IAccountStatusRaw } from 'models/user.model'

export const getAccountStatusFromRawStatus = (
  rawAccountStatus: IAccountStatusRaw,
): IAccountStatus => ({
  existingUuid: rawAccountStatus.uuid,
  hasAccount: rawAccountStatus.has_account,
  hasAccessToApp: rawAccountStatus.access_to_app,
})
